var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOraiDexFullLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 44,
    viewBox: "0 0 152 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3037_38181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19.7264H2.94673C3.01127 19.1572 3.10515 18.5939 3.21663 18.0365C3.4748 16.775 3.86205 15.5311 4.36078 14.3459C4.85365 13.1783 5.46386 12.0576 6.17382 11.0015C6.87792 9.95706 7.68763 8.9772 8.57948 8.08534C9.47133 7.19349 10.4512 6.38378 11.4956 5.67969C12.5459 4.96973 13.6724 4.35952 14.84 3.86665C16.0253 3.36792 17.2692 2.98067 18.5307 2.7225C19.0881 2.61102 19.6514 2.51713 20.2205 2.45259V0C9.82925 1.06788 1.56201 9.32924 0.5 19.7264ZM42.0533 24.2795C41.9887 24.8486 41.8949 25.4119 41.7834 25.9693C41.5252 27.2308 41.138 28.4747 40.6392 29.66C40.1464 30.8276 39.5361 31.9483 38.8262 33.0044C38.1221 34.0488 37.3124 35.0287 36.4205 35.9205C35.5287 36.8124 34.5488 37.6221 33.5044 38.3262C32.4541 39.0361 31.3276 39.6464 30.16 40.1392C28.9747 40.638 27.7308 41.0252 26.4693 41.2834C25.9119 41.3949 25.3486 41.4887 24.7795 41.5533V44C35.1708 42.938 43.438 34.6708 44.5 24.2795H42.0533ZM14.84 40.1392C13.6724 39.6464 12.5517 39.0361 11.4956 38.3262C10.4512 37.6221 9.47133 36.8124 8.57948 35.9205C7.68763 35.0287 6.87792 34.0488 6.17382 33.0044C5.46386 31.9541 4.85365 30.8276 4.36078 29.66C3.86205 28.4747 3.4748 27.2308 3.21663 25.9693C3.10515 25.4119 3.01127 24.8486 2.94673 24.2795H0.5C1.56201 34.6708 9.82925 42.938 20.2205 44V41.5533C19.6514 41.4887 19.0881 41.3949 18.5307 41.2834C17.2692 41.0311 16.0253 40.6438 14.84 40.1392ZM24.7795 0V2.44673C25.3486 2.51127 25.9119 2.60515 26.4693 2.71663C27.7308 2.9748 28.9747 3.36205 30.16 3.86078C31.3276 4.35365 32.4483 4.96386 33.5044 5.67382C34.5488 6.37792 35.5287 7.18763 36.4205 8.07948C37.3124 8.97133 38.1221 9.95119 38.8262 10.9956C39.5361 12.0459 40.1464 13.1724 40.6392 14.34C41.138 15.5253 41.5252 16.7692 41.7834 18.0307C41.8949 18.5881 41.9887 19.1514 42.0533 19.7205H44.5059C43.438 9.32924 35.1766 1.06788 24.7795 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2382 10.5391H11.043V14.7343H15.2382V10.5391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9726 10.5391H28.3105V16.2011H33.9726V10.5391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9732 26.0234V33.4692H26.5273V26.0234H33.9732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4838 31.0215H11.043V33.4623H13.4838V31.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.508 22.1623L11.1955 33.4689H11.043V33.3105L22.3496 22.0039L22.508 22.1623Z",
    fill: "url(#paint0_linear_3037_38181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9728 10.5391V10.6975L28.4633 16.2012L22.6662 22.0041L22.5078 21.8456L28.3107 16.0486L33.8144 10.5391H33.9728Z",
    fill: "url(#paint1_linear_3037_38181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.508 21.8456L22.3496 22.0041L11.043 10.6975V10.5391H11.1955L22.508 21.8456Z",
    fill: "url(#paint2_linear_3037_38181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9728 33.3105V33.4689H33.8144L22.5078 22.1623L22.6662 22.0039L33.9728 33.3105Z",
    fill: "url(#paint3_linear_3037_38181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8237 22.0707C72.7818 26.1773 70.2591 30.284 64.6773 30.284C59.0956 30.284 56.5059 26.2695 56.5059 22.0874C56.5059 17.9053 59.1878 13.7148 64.6773 13.7148C70.1418 13.7232 72.8656 17.9221 72.8237 22.0707ZM59.456 22.1377C59.523 24.7442 60.931 27.5434 64.6773 27.5434C68.4236 27.5434 69.8317 24.7274 69.8736 22.1209C69.9155 19.439 68.4236 16.447 64.6773 16.447C60.931 16.447 59.3889 19.4642 59.456 22.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9532 18.7353L78.1544 20.026C79.0176 18.6431 80.1742 18.4336 81.3056 18.4336C82.4622 18.4336 83.5769 18.8862 84.1887 19.498L82.9399 21.9033C82.37 21.4256 81.8504 21.1742 80.9452 21.1742C79.4953 21.1742 78.1544 21.9452 78.1544 24.0153V29.9155H75.3887V18.7353H77.9532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.682 18.7351H97.3387V29.9237H94.7323L94.5982 28.2894C93.9612 29.6052 92.218 30.2421 90.9692 30.2673C87.6587 30.2924 85.2031 28.2475 85.2031 24.3252C85.2031 20.4699 87.7677 18.4501 91.0363 18.4669C92.5365 18.4669 93.9612 19.1709 94.5982 20.2856L94.682 18.7351ZM87.9605 24.3168C87.9605 26.4539 89.4355 27.7195 91.2709 27.7195C95.629 27.7195 95.629 20.9309 91.2709 20.9309C89.4355 20.9393 87.9605 22.188 87.9605 24.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.255 15.5827C103.255 17.7366 99.9863 17.7366 99.9863 15.5827C99.9863 13.4204 103.255 13.4204 103.255 15.5827ZM100.238 18.692V29.9225H103.003V18.692H100.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.251 21.8442C120.318 25.8587 117.871 29.9234 112.306 29.9234C110.354 29.9234 108.015 29.9234 106.062 29.9234V14.0332C108.015 14.0332 110.354 14.0332 112.306 14.0332C117.762 14.0332 120.184 17.922 120.251 21.8442ZM109.046 27.0404H112.315C115.927 27.0404 117.352 24.4088 117.285 21.8191C117.218 19.3467 115.768 16.8743 112.315 16.8743H109.046V27.0404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.641 29.9234H122.748C122.748 24.6351 122.748 19.3216 122.748 14.0332H134.641V16.9414H125.723V20.5955H134.322V23.3863H125.723V26.9734H134.641V29.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.302 14.0332H151.596V14.1673L146.216 21.8861L151.755 29.8313V29.9234H148.395L144.33 23.9562L140.265 29.9234H136.904V29.8313L142.419 21.8861L137.064 14.1673V14.0332H140.357L144.33 19.9585L148.302 14.0332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3037_38181",
    x1: 22.4277,
    y1: 22.0815,
    x2: 13.4513,
    y2: 31.0579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3037_38181",
    x1: 22.5843,
    y1: 21.926,
    x2: 28.281,
    y2: 16.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3037_38181",
    x1: 22.3776,
    y1: 21.8764,
    x2: 15.2089,
    y2: 14.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3037_38181",
    x1: 22.5618,
    y1: 22.0595,
    x2: 26.6575,
    y2: 26.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9809,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3037_38181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOraiDexFullLight);
export default __webpack_public_path__ + "static/media/OraiDEX_full_light.1114c113b873894fbf7d240b9422bf4d.svg";
export { ForwardRef as ReactComponent };